/**
 * @ngdoc object
 * @name bo.objects.controller:BoObjectsListController
 *
 * @description
 *
 */

class BoObjectsListController {

    constructor(BoObjects, $state, NavService) {
        this.state = $state;
        this.navService = NavService;

        this.store = BoObjects;
        this.store.commit('setVm', this);

        this._updateNavigation();
    }

    _updateNavigation() {
        if(!this.model) {
            return;
        }

        this.navService.overrideMainSideNavActions([
            {
                key: 'create-object',
                title: 'Create',
                icon: 'plus-circle',
                action: () => {
                    this.state.go('app.bo.objects.create');
                }
            }
        ])
    }

    addNew() {
        this.state.go('app.bo.objects.create', {
            store: this.store
        });
    }

    goToDetails(event) {
        this.state.go('app.bo.objects.details', {
            objectId: event.row.id,
            store: this.store
        });
    }
}

BoObjectsListController.$inject = [
    'BoObjects',
    '$state',
    'NavService'
];

angular
    .module('festzelt-os.modules.bo.objects')
    .controller('BoObjectsListController', BoObjectsListController);



// WEBPACK FOOTER //
// ./src/app/modules/bo/objects/controllers/list-controller.js